<template>
  <div class="order-logs">
    <h3>操作日志</h3>
    <table class="table table-sm">
      <thead>
        <tr>
          <th>时间</th>
          <th>用户</th>
          <th>内容</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="log in logs">
        <td nowrap><local-time :time="log.created_at"></local-time></td>
        <td>{{log.commander || ''}}</td>
        <td>{{log.message}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import LocalTime from '@/components/_small/LocalTime'

function loadData () {
  this.$http.get(`/api/orders/${this.orderNo}/logs`).then(response => {
    this.logs = response.data.data
  })
}

export default {
  name: 'order-logs',
  props: ['orderNo'],
  data () {
    return {
      logs: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData
  },
  components: {
    LocalTime
  }
}
</script>
